export const formatLastSeen = (timestamp) => {
  const lastSeen = new Date(timestamp);
  const now = new Date();

  const isToday =
    lastSeen.getDate() === now.getDate() &&
    lastSeen.getMonth() === now.getMonth() &&
    lastSeen.getFullYear() === now.getFullYear();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    lastSeen.getDate() === yesterday.getDate() &&
    lastSeen.getMonth() === yesterday.getMonth() &&
    lastSeen.getFullYear() === yesterday.getFullYear();

  const hours = lastSeen.getHours().toString().padStart(2, '0');
  const minutes = lastSeen.getMinutes().toString().padStart(2, '0');
  const timePart = `${hours}:${minutes}`;

  const monthsUA = [
    'січня',
    'лютого',
    'березня',
    'квітня',
    'травня',
    'червня',
    'липня',
    'серпня',
    'вересня',
    'жовтня',
    'листопада',
    'грудня',
  ];

  if (isToday) {
    return `Сьогодні о ${timePart}`;
  } else if (isYesterday) {
    return `Вчора о ${timePart}`;
  } else {
    const day = lastSeen.getDate();
    const month = monthsUA[lastSeen.getMonth()];
    const year = lastSeen.getFullYear();
    const isCurrentYear = year === now.getFullYear();
    if (isCurrentYear) {
      return `${day} ${month} о ${timePart}`;
    } else {
      return `${day} ${month} ${year} р. о ${timePart}`;
    }
  }
};
